/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Column,
  DataGrid,
  HeaderFilter,
  Pager,
  Paging,
  FilterRow,
} from 'devextreme-react/data-grid';

import { FormGroup, Input } from 'reactstrap';
import { ContainerGrid } from './styles';
import {
  gridGroupSubMenuDataSource,
  handleUpdateGrupoSubMenu,
} from '../../GruposServices';

function Lista({ setLoading, loading, form }) {
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(15);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }
  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];
  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  const checkRender = (e) => (
    <FormGroup
      style={{
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Input
        disabled={loading}
        type="checkbox"
        checked={e.data.check}
        onChange={() => {
          handleUpdateGrupoSubMenu(
            !e.data.check,
            e.data.id,
            e.data.idMenuSub,
            e,
            form,
            setLoading
          );
        }}
      />
    </FormGroup>
  );
  return (
    <ContainerGrid>
      <h5>Selecione os sub menus que o grupo terá acesso</h5>
      <DataGrid
        dataSource={gridGroupSubMenuDataSource}
        remoteOperations
        showBorders
        allowColumnReordering
        allowColumnResizing
        columnAutoWidth
        onOptionChanged={handleOptionChange}
      >
        <Pager
          visible
          showPageSizeSelector
          allowedPageSizes={[10, 15, 30]}
          showInfo
        />
        <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
        <FilterRow
          visible={filterOptions.showFilterRow}
          applyFilter={filterOptions.currentFilter}
        />
        <Column
          dataField="idMenuSub"
          caption="Id do sub menu"
          alignment="left"
          filterOperations={false}
          width={100}
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="left"
          dataField="nome"
          caption="Nome do sub menu"
          filterOperations={false}
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="left"
          dataField="descricao"
          caption="Descrição do sub menu"
          filterOperations={false}
        >
          <HeaderFilter groupInterval={100} />
        </Column>
        <Column
          alignment="center"
          dataField="check"
          caption="Vincular?"
          editCellRender={checkRender}
          width="20%"
        />
      </DataGrid>
    </ContainerGrid>
  );
}

export default Lista;
